import { render } from "./TabsNavigation.vue?vue&type=template&id=84c8a174&scoped=true"
import script from "./TabsNavigation.vue?vue&type=script&lang=js"
export * from "./TabsNavigation.vue?vue&type=script&lang=js"

import "./TabsNavigation.vue?vue&type=style&index=0&id=84c8a174&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c8a174"]])

export default __exports__